export enum Permissions {
  QUERY_RATES = 'query_rates',
  UPLOAD_DOCUMENT = 'upload_document',
  MANAGE_USERS = 'manage_users',
  MANAGE_ORGANIZATION_SETTINGS = 'manage_organization_settings',
}
